import React from 'react';
import { IconContainer } from './IconContainer';

const DownloadIcon = (props) => {
    return (
        <IconContainer aria-label="icon: download" cursor="pointer" { ...props }>
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 15.8334H18V17.5H3V15.8334ZM11.3333 10.9767L16.3925 5.91669L17.5708 7.09502L10.5 14.1667L3.42917 7.09585L4.6075 5.91669L9.66667 10.975V1.66669H11.3333V10.9767Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { DownloadIcon };